import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SnackbarService, SnackbarStatus } from '@prism/angular-shared';
import { BehaviorSubject, catchError, delay, EMPTY, first, from, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { ScreenService } from '../shared/services/screen.service';
import { UserApiService } from '../shared/services/user-api.service';
import { CoreActions } from '../shared/state/core';

@Component({
  selector: 'prism-client-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
})
export class NoAccessComponent implements OnInit, OnDestroy {


  public showPassword$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public submitEnabled$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public loginInProgress$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public loginSuccessful$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private unsubscribe$: Subject<void> = new Subject();



  constructor(
    private store: Store,
    private router: Router,
    private snackbarService: SnackbarService,
    private screenService: ScreenService,
    private userApiService: UserApiService,
  ) { }

  ngOnInit() {
    this.store.dispatch(CoreActions.ClearCurrentUser());
    this.screenService.hideMainHeader$.next(true);

    const fiveMinutes = 5 * 60 * 1000
    setTimeout(() => {
      window.location.reload()
    }, fiveMinutes)
  }

  ngOnDestroy() {
    this.screenService.hideMainHeader$.next(false);
  }

  public login() {

  }

  public navigateToBadgeLogin() {
    this.router.navigate(['/login'])
  }

  public toggleShowPassword() {
    this.showPassword$.next(!this.showPassword$.value)
  }

}
